import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "..";
import { shouldProductBeVisible } from "@/helpers/products";
import { productAdapter } from "./slice";
import { Product } from "@/types/product";
import { Category } from "@/types/category";
import { getTextFromTranslations } from "@/helpers/translation";

const selectSelf = (state: RootState) => state.product;

export const selectProducts = createSelector(selectSelf, (state) => ({
  isLoading: state.isLoading,
  isError: state.isError,
  products: productAdapter.getSelectors().selectAll(state),
}));
export const selectProductById = createSelector(
  [selectSelf, (_state: RootState, id: Product["id"] | undefined) => id],
  (state, id) => (id ? productAdapter.getSelectors().selectById(state, id) : undefined)
);
export const makeSelectVisibleProductIds = () => {
  return createSelector(
    [
      selectProducts,
      (_state: RootState, options: { category?: Category; sortLanguage?: string }) => options,
    ],
    (state, { sortLanguage, category }) => {
      const getName = (p: Product) =>
        getTextFromTranslations(p.translations, { preferredLanguage: sortLanguage })?.name;

      return state.products
        .filter(
          (p) => shouldProductBeVisible(p) && (category ? category.productIds.includes(p.id) : true)
        )
        .sort((a, b) => getName(a)?.localeCompare(getName(b) ?? "") ?? 0)
        .map((p) => p.id);
    }
  );
};
